const BLOG_TAGS_LOADING = "BLOG_TAGS_LOADING";
const BLOG_TAGS_ERROR = "BLOG_TAGS_ERROR";
const BLOG_TAGS_SUCCESS = "BLOG_TAGS_SUCCESS";

export { BLOG_TAGS_LOADING, BLOG_TAGS_ERROR, BLOG_TAGS_SUCCESS };